import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Dialog, {DialogTitle} from 'material-ui/Dialog';

class SimpleDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    handleRequestClose = () => {
        this.props.onClose();
    };

    handleListItemClick = value => {
        this.props.onClose(value);
    };

    render() {
        const {title, Body} = this.props;
        const {classes, onClose, ...other} = this.props;

        return (
            <Dialog onClose={this.handleRequestClose} {...other}>
                <DialogTitle>{title}</DialogTitle>
                <div style={{padding: 15}}>
                    <Body/>
                </div>
            </Dialog>
        );
    }
}

SimpleDialog.propTypes = {
    onClose: PropTypes.func
};
export default SimpleDialog;



// WEBPACK FOOTER //
// ./components/customized/dialogs/simpleDialog/SimpleDialog.js